import script from "./DeadlinesWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeadlinesWidget.vue?vue&type=script&setup=true&lang=ts"

import "./DeadlinesWidget.vue?vue&type=style&index=0&id=16cd14df&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16cd14df"]])

export default __exports__